export default function SkeletonLoader({ type = 'story-card', count }) {
  if (type === 'story-grid') {
    return (
      <div className="skeleton-grid">
        {[...Array(count || 6)].map((_, i) => <StoryCardSkeleton key={i} />)}
      </div>
    )
  }
  if (type === 'profile') return <ProfileSkeleton />
  if (type === 'reader') return <ReaderSkeleton />
  if (type === 'list-item') {
    return (
      <>
        {[...Array(count || 5)].map((_, i) => <ListItemSkeleton key={i} />)}
      </>
    )
  }
  return <StoryCardSkeleton />
}

function StoryCardSkeleton() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-pulse skeleton-card__cover" />
      <div className="skeleton-card__body">
        <div className="skeleton-card__author-row">
          <div className="skeleton-pulse skeleton-card__avatar" />
          <div className="skeleton-pulse skeleton-card__author-name" />
        </div>
        <div className="skeleton-pulse skeleton-card__title" />
        <div className="skeleton-pulse skeleton-card__desc skeleton-card__desc--long" />
        <div className="skeleton-pulse skeleton-card__desc skeleton-card__desc--short" />
        <div className="skeleton-card__footer">
          <div className="skeleton-pulse skeleton-card__stat" />
          <div className="skeleton-pulse skeleton-card__stat" />
          <div className="skeleton-pulse skeleton-card__stat" />
        </div>
      </div>
    </div>
  )
}

function ProfileSkeleton() {
  return (
    <div className="skeleton-profile">
      <div className="skeleton-pulse skeleton-profile__banner" />
      <div className="skeleton-profile__header">
        <div className="skeleton-pulse skeleton-profile__avatar" />
        <div className="skeleton-pulse skeleton-profile__name" />
        <div className="skeleton-pulse skeleton-profile__username" />
      </div>
      <div className="skeleton-profile__stories">
        {[...Array(3)].map((_, i) => <StoryCardSkeleton key={i} />)}
      </div>
    </div>
  )
}

function ReaderSkeleton() {
  return (
    <div className="skeleton-reader">
      <div className="skeleton-pulse skeleton-reader__header" />
      <div className="skeleton-reader__content">
        <div className="skeleton-pulse skeleton-reader__line skeleton-reader__line--full" />
        <div className="skeleton-pulse skeleton-reader__line skeleton-reader__line--full" />
        <div className="skeleton-pulse skeleton-reader__line skeleton-reader__line--medium" />
        <div className="skeleton-pulse skeleton-reader__line skeleton-reader__line--full" />
        <div className="skeleton-pulse skeleton-reader__line skeleton-reader__line--long" />
        <div className="skeleton-pulse skeleton-reader__line skeleton-reader__line--short" />
        <div className="skeleton-pulse skeleton-reader__line skeleton-reader__line--full" />
        <div className="skeleton-pulse skeleton-reader__line skeleton-reader__line--full" />
        <div className="skeleton-pulse skeleton-reader__line skeleton-reader__line--medium" />
      </div>
    </div>
  )
}

function ListItemSkeleton() {
  return (
    <div className="skeleton-list-item">
      <div className="skeleton-pulse skeleton-list-item__avatar" />
      <div className="skeleton-list-item__lines">
        <div className="skeleton-pulse skeleton-list-item__primary" />
        <div className="skeleton-pulse skeleton-list-item__secondary" />
      </div>
    </div>
  )
}
